/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import Imgix from 'js/components/Imgix';

import { useTheme } from '@coursera/cds-core';
import type { Theme } from '@coursera/cds-core';

const Border = 1;

const styles = {
  logo: (_: Theme, width: number, padding: number, borderRadius: number) => css`
    flex-shrink: 0;
    border-radius: ${borderRadius}px;
    overflow: hidden;
    width: ${width}px;
    height: ${width}px;
    padding: ${padding}px;
    border: ${Border}px solid var(--cds-color-grey-50);

    @supports (background: light-dark(transparent, #fff)) {
      /* In dark mode we want the background to be white */
      /* stylelint-disable-next-line color-no-hex, function-no-unknown */
      background: light-dark(transparent, #fff);
    }
  `,
};

type Props = {
  src: string;
  name?: string;
  width?: number;
  borderRadius?: number;
};

const PartnerSquareLogo = ({ src, name, width = 50, borderRadius = 8 }: Props) => {
  const theme = useTheme();
  if (!src) {
    return null;
  }

  const padding = Math.floor(width / 10);
  const imageSize = width - padding * 2 - Border * 2;

  return (
    <div css={styles.logo(theme, width, padding, borderRadius)}>
      <Imgix src={src} alt={name ?? ''} maxWidth={imageSize} maxHeight={imageSize} imgParams={{ fit: 'fill' }} />
    </div>
  );
};

export default PartnerSquareLogo;
